import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = 'Privacy Policy | Sunlight Grounds Care';
  }, []);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacy-policy-page">
      {/* Hero Section */}
      <section className="bg-[#1a2e44] py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white">
            Privacy Policy
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="bg-white p-8 md:p-12 rounded-lg shadow-sm border border-slate-200">
            <h2 className="text-2xl font-bold text-[#1a2e44] mb-6">
              Sunlight Grounds Care Privacy Policy
            </h2>
            
            <div className="prose prose-slate max-w-none space-y-6">
              <p className="text-slate-600">
                We collect personal information such as name, phone number, email, and service details to provide and improve our services.
              </p>

              <div>
                <h3 className="text-lg font-bold text-[#1a2e44] mb-3">
                  We use this information to:
                </h3>
                <ul className="list-disc pl-6 space-y-2 text-slate-600">
                  <li>Schedule and manage services</li>
                  <li>Communicate with clients</li>
                  <li>Send service updates and notifications</li>
                </ul>
              </div>

              <p className="text-slate-600">
                We do not sell or share your personal information with third parties for marketing purposes.
              </p>

              <p className="text-slate-600 font-medium">
                SMS consent is not shared with third parties or affiliates.
              </p>

              <p className="text-slate-600">
                Your information is stored securely and only used for business operations.
              </p>

              <div className="pt-6 border-t border-slate-200">
                <p className="text-slate-600">
                  For questions, contact us at{' '}
                  <a href="tel:6267377475" className="text-[#1a2e44] font-medium hover:underline">
                    (626) 737-7475
                  </a>
                </p>
              </div>

              <div className="pt-6">
                <Link 
                  to="/terms" 
                  className="text-[#1a2e44] font-medium hover:underline"
                >
                  View our SMS Terms of Service →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
